module.exports = __webpack_public_path__ + "img/BV.aac1e6b5.svg";